export const inventoryPermissions = {
    INVENTORY_ACCESS: {
        key: 'inventory.access',
        name: 'Access',
    },
}
